import React, {useEffect} from "react";
import { getTimeWorkedOnText } from "../../helpers";
import { StatusTypes } from "../../variables";

const TaskBox = ({
  title,
  status,
  timeWorkedOn,
  active,
  onChangeActiveTask,
  onChangeStatus,
}) => {
  let deafultBoxStyles = `transition-[height] duration-300 flex justify-between 
  mb-4 p-4 shadow-lg border-2 rounded-xl cursor-pointer items-center`;

  let incompletedBoxStyles = ` hover:bg-indigo-50 hover:border-indigo-300 
  dark:bg-primary-dark dark:hover:bg-indigo-900 dark:hover:border-indigo-500 
    ${
      active
        ? " border-indigo-300 dark:border-indigo-500"
        : " bg-white border-slate-50 dark:border-transparent "
    } `;

  let completedBoxStyles = `dark:bg-indigo-900 hover:border-lime-400 
    dark:hover:border-indigo-500 ${
      active
        ? "bg-lime-50 border-lime-400 dark:border-indigo-500"
        : "bg-lime-50 border-lime-200 dark:border-transparent"
    }`;

  let boxStyles = [deafultBoxStyles];
  //  Apply styles
  if (status === StatusTypes.COMPLETED) boxStyles.push(completedBoxStyles);
  else boxStyles.push(incompletedBoxStyles);

  
  // Worked on time label
  const timeWorkedOnLabel = getTimeWorkedOnText(timeWorkedOn);

  // Parameter passed to checkbox update function
  const nextStatus =
    status === StatusTypes.COMPLETED
      ? StatusTypes.INPROGRESS
      : StatusTypes.COMPLETED;

  return (
    <div className={boxStyles.join(" ")}>
      {/* Title */}
      <div
        className="flex w-full mr-4 justify-between items-center text-center"
        onClick={(e) => {
          e.stopPropagation();
          onChangeActiveTask();
        }}
      >
        <h1 className="">{title}</h1>
        {/* Worked on time */}
        <p className="text-indigo-500 w-[8rem]">{timeWorkedOnLabel}</p>
      </div>
      {/* Checkbox */}
      <input
        checked={status === StatusTypes.COMPLETED}
        onChange={(e) => {
          e.stopPropagation();
          onChangeStatus(nextStatus);
        }}
        type="checkbox"
        className={`form-checkbox text-lime-500 border-2 ${
          status === StatusTypes.COMPLETED
            ? "border-lime-500"
            : "border-slate-400"
        } rounded-sm text-lg focus:ring-0 focus:shadow-none focus:ring-offset-0 cursor-pointer`}
      />
    </div>
  );
};

export default TaskBox;
